<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div class="relative mb-4 bg-gray-50 rounded-lg p-4" :class="chartHeightClass">
          <b-skeleton animation="wave" height="100%" width="100%"></b-skeleton>
        </div>
      </template>
      <div class="relative mb-4" :class="chartHeightClass">
        <line-chart
          v-if="chartDataLoaded"
          :chart-data="chartData"
          :options="chartOptions"
          style="height: 100%; width: 100%;"
        ></line-chart>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import LineChart from "./../LineChart.js";
import { getAccuracyProgress } from "@/services/stats.service";

export default {
  name: 'OverallAccuracyGraph',

  components: {
    LineChart,
  },

  data() {
    return {
      loading: true,
      chartDataLoaded: false,
      chartData: { // Datos del gráfico
        labels: [], // ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'],
        datasets: [
          {
            label: 'Precisión General',
            data: [], // [0, 0, 0, 0],
            backgroundColor: 'rgba(148, 163, 184, 0.15)',
            borderColor: 'rgba(148, 163, 184, 0.8)',
            borderWidth: 3,
            pointBackgroundColor: [],
            pointBorderColor: '#FFFFFF',
            pointBorderWidth: 2,
            pointRadius: 4,
            tension: 0.25
          }
        ]
      },
      chartOptions: { // Opciones del gráfico (Chart.js v2)
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 800,
          easing: "easeOutQuart",
        },
        legend: {
          display: false // Oculta la leyenda como en la imagen
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 100, // Asumiendo que es un %
              callback: function (value) {
                return value + '%'; // Añade el símbolo % al eje Y
              }
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false // Oculta las líneas de la cuadrícula X
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return 'Precisión: ' + tooltipItem.yLabel + '%';
            }
          }
        }
      },
    }
  },

  props: {
    receivedTimeRange: {
      type: String,
      default: ''
    },
    isPremium: {
      type: Boolean,
      default: true
    },
    forStudentId: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    chartHeightClass() {
      return "h-64 md:h-80";
    },
  },

  watch: {
    receivedTimeRange(timeRange) {
      if (!this.isPremium) return;
      this.loadChartData(timeRange);
    },
    isPremium(newValue) {
      if (newValue && this.receivedTimeRange) {
        this.loading = true;
        this.loadChartData(this.receivedTimeRange);
      }
    },
    forStudentId() {
      if (this.isPremium && this.receivedTimeRange) {
        this.loading = true;
        this.loadChartData(this.receivedTimeRange);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.loadChartData(this.receivedTimeRange);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async loadChartData(timeRange) {
      if (timeRange === '' || !this.isPremium) {
        return;
      }

      console.log("Cargando datos para el rango:", timeRange);
      this.chartDataLoaded = false; // Oculta el gráfico mientras carga

      try {
        const response = await getAccuracyProgress(timeRange, this.forStudentId);

        this.chartData.labels = response.labels;
        this.chartData.datasets[0].data = response.data;
        this.chartData.datasets[0].pointBackgroundColor = (response.data || []).map((value) =>
          value > 0 ? "rgba(34, 197, 94, 1)" : "rgba(148, 163, 184, 1)"
        );

        this.chartDataLoaded = true; // Muestra el gráfico
        this.loading = false; // Ocultar skeleton inmediatamente después de cargar

      } catch (error) {
        console.error("Error al cargar datos del gráfico:", error);
        this.loading = false; // Ocultar skeleton incluso si hay error
      }
    },
  },
};
</script>
